
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcasts",
      function () {
        return require("private-next-pages/podcasts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcasts"])
      });
    }
  